import { COUNTRIES_DATA_LIST } from "repoV2/utils/common/location/countriesData";

/**
 * function to check if the country code is valid
 */
export const checkIsValidCountryCode = (countryCode: string) =>
    !!countryCode &&
    typeof countryCode === "string" &&
    COUNTRIES_DATA_LIST.some(i => i.code === countryCode);
